import React from 'react';

import FlatButton from '@material-ui/core/Button';
import Lottie from 'react-lottie';
import styled from 'styled-components';

import { AccentColor } from 'helpers/AccentColorHelper';
import { getTranslatedString } from 'helpers/i18n';
import errorAnimationData from 'assets/error.json';

const StyledH3 = styled.h3`
  text-align: center;
`;
const StyledP = styled.p`
  text-align: center;
`;

export const BamboraFailure = ({ handleClose, paymentError, paymentAuthorizeError }) => {
  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: errorAnimationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  let errorMessage = getTranslatedString('bamboraCheckout.paymentFailure');

  let showContactIssuer = false;
  if (paymentError && paymentError.bpms_error_message && paymentError.message) {
    errorMessage = paymentError.message;
    showContactIssuer = true;
  } else if (
    paymentAuthorizeError &&
    paymentAuthorizeError.bpms_error_message &&
    paymentAuthorizeError.message
  ) {
    errorMessage = paymentAuthorizeError.message;
    showContactIssuer = true;
  }

  return (
    <React.Fragment>
      <Lottie options={defaultOptions} height={150} width={150} />
      <StyledH3>{errorMessage}</StyledH3>
      {showContactIssuer === true && (
        <StyledP>{getTranslatedString('bamboraCheckout.pleaseContactIssuer')}</StyledP>
      )}

      <div className="row" style={{ textAlign: 'center', marginBottom: '2rem' }}>
        <FlatButton
          variant="contained"
          onClick={handleClose}
          style={{
            color: 'white',
            backgroundColor: AccentColor(),
            paddingLeft: '30px',
            paddingRight: '30px',
          }}
        >
          {getTranslatedString('bamboraCheckout.closeFailure')}
        </FlatButton>
      </div>
    </React.Fragment>
  );
};
